/**
 * Anchor Link Fixes for mobile devices.
 * Hides the mobile menu when an anchor link is clicked.
 */
import { closeMobileMenu } from './main-menu';

const anchorLinks = [...document.querySelectorAll('.site-header__main-menu .sub-menu .menu-item')];

if (anchorLinks.length) {
	const handleClickEvent = (link) => {
		link.addEventListener('click', (e) => {
			const aTag = e.target.closest('a');
			const { href } = aTag;
			if (typeof href !== 'undefined') {
				if (href.indexOf('#') !== -1) {
					closeMobileMenu();
				}
			}
		});
	};
	anchorLinks.map((link) => handleClickEvent(link));
}
